import { useSearchParams } from 'react-router-dom'

// The dialog is mounted once in Layout and opened by a URL param, so the three
// entry points (dashboard quick action, mobile quick action, profile button)
// stay ordinary navigation instead of each needing to reach a shared component.
export function useSendTaskParam() {
  const [params, setParams] = useSearchParams()

  const open = params.get('sendTask') === '1'
  const presetAssignee = params.get('to') || undefined

  const close = () => {
    const next = new URLSearchParams(params)
    next.delete('sendTask')
    next.delete('to')
    setParams(next, { replace: true })
  }

  const openFor = (userId?: string) => {
    const next = new URLSearchParams(params)
    next.set('sendTask', '1')
    if (userId) next.set('to', userId)
    setParams(next)
  }

  return { open, presetAssignee, close, openFor }
}
